import React from 'react';
import Helmet from 'react-helmet';
import brLocale from 'date-fns/locale/pt-BR';

import DateFnsUtils from '@date-io/date-fns';
import { withStyles } from '@material-ui/core/styles';

import 'react-day-picker/lib/style.css';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import './style.css'

const useStyles = () => ({
  flex: {
    display: 'flex',
    flexDirection: 'column',
  },
  separator: {
    padding: '0px 10px',
    color: '#757575',
  },
  sizeFont: {
    fontSize: 14,
  },
  span: {
    width: '100%',
    color: '#757575',
    fontSize: 14,
  },
  DayPickerRange: {
    width: 'max-content',
  }
})

class InputDateRange extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      from: null,
      to: null
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.clearAll !== prevProps.clearAll && this.props.clearAll) {
      this.setState({
        from: '',
        to: ''
      }
      )
    }

    return null
  }

  // showFromMonth() {
  //   const { from, to } = this.state;
  //   if (!from) {
  //     return;
  //   }
  //   if (moment(to).diff(moment(from), 'months') < 2) {
  //     this.to.getDayPicker().showMonth(from);
  //     this.props.getInputDateRange(this.state.from, this.state.to)
  //   }
  // }

  handleFromChange = from => {
    this.setState({ from }, () => { this.props.getInputDateRange(this.state.from, this.state.to) });
  }

  handleToChange = to => {
    this.setState({ to }, () => { this.props.getInputDateRange(this.state.from, this.state.to) });
    // this.showFromMonth()
  }

  render() {
    const { classes } = this.props
    const { from, to } = this.state;
    return (
      <div className={classes.flex}>
        <span className={classes.span}>{this.props.title || 'PERÍODO'}</span>
        <div className={classes.DayPickerRange}>

          <span className={`${classes.span} ${classes.sizeFont}`}>De </span>

          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={brLocale}>
            <KeyboardDatePicker
              id="date-picker-inline"
              placeholder=""
              variant="outlined"
              format="dd/MM/yyyy"
              value={this.props.clearAll ? null : from}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              maxDate={to ? to : undefined}
              onChange={this.handleFromChange}
              autoOk={true}
              okLabel="Ok"
              cancelLabel="Cancelar"
              invalidDateMessage="Data inválida."
              minDateMessage="A data inserida é inválida."
              maxDateMessage="A data inserida é inválida."
              views={['year', 'date']}
              style={{ width: 145, marginLeft: 5 }}
            // disableToolbar={true}
            // openTo="year"
            />
          </MuiPickersUtilsProvider>

          <span className={classes.separator}>a</span>

          <span className={classes.DayPickerRange}>

            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={brLocale}>
              <KeyboardDatePicker
                //ref={el => (this.to = el)}
                id="date-picker-inline"
                placeholder=""
                variant="outlined"
                format="dd/MM/yyyy"
                value={this.props.clearAll ? null : to}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                minDate={from ? from : undefined}
                onChange={this.handleToChange}
                autoOk={true}
                okLabel="Ok"
                cancelLabel="Cancelar"
                invalidDateMessage="Data inválida."
                minDateMessage="A data inserida é inválida."
                maxDateMessage="A data inserida é inválida."
                style={{ width: 145, marginRight: 10 }}
              // disableToolbar={true}
              // openTo="year"
              />
            </MuiPickersUtilsProvider>
          </span>
          <Helmet>
            <style>
              {`
  .InputFromTo .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #f0f8ff !important;
    color: #4a90e2;
  }
  .InputFromTo .DayPicker-Day {
    border-radius: 0 !important;
  }
  .InputFromTo .DayPicker-Day--start {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  .InputFromTo .DayPicker-Day--end {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
  .InputFromTo .DayPickerInput-Overlay {
    width: 550px;
  }
  .InputFromTo-to .DayPickerInput-Overlay {
    margin-left: -198px;
  }
`}</style>
          </Helmet>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(InputDateRange)